import { useNavigate } from 'react-router';
import { useLogoutMutation } from '../api/queries';

/** Esce: chiude la sessione, svuota la cache e porta al login. */
export function useLogout() {
  const navigate = useNavigate();
  const { mutateAsync } = useLogoutMutation();
  return async () => {
    await mutateAsync();
    navigate('/login');
  };
}
